import { Result, validatedApiCall } from '../api';
import { UpdatePasswordDTO } from '../../types/forgotPassword/forgotPassword';
import { APIValidationError } from '../../types/api/api';

export const changePassword = async (
  data: UpdatePasswordDTO,
): Promise<Result<boolean, APIValidationError>> => {
  return validatedApiCall<boolean>(`/api/auth/updatePassword`, {
    method: 'PUT',
    auth: false,
    body: JSON.stringify(data),
  });
};
